import React from 'react';

import PublicationLanding from '../../images/publications/publications-cover.png';
import './Landing.css';

function LandingSection() {
  return (
    <div id="publicationsLanding">
      <img src={PublicationLanding} alt="" />
      <div id="publicationsHeader">
        <h1>
          Publicações
          <br />
          e Prêmios
        </h1>
      </div>
    </div>
  );
}

export default LandingSection;
